import { render, staticRenderFns } from "./UploadImageAvatar.vue?vue&type=template&id=668bcece&scoped=true"
import script from "./UploadImageAvatar.vue?vue&type=script&lang=js"
export * from "./UploadImageAvatar.vue?vue&type=script&lang=js"
import style0 from "./UploadImageAvatar.vue?vue&type=style&index=0&id=668bcece&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "668bcece",
  null
  
)

export default component.exports